import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AgentLogin from './components/agent/AgentLogin';
import AgentDashboard from './components/agent/AgentDashboard';
import CustomerPortal from './components/customer/CustomerPortal';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import DetentionReport from './Reports/DetentionReport';
import CompletedVoyageReport from './Reports/CompletedVoyageReport';
import ContainerDwellTimeReport from './Reports/ContainerDwellTimeReport';
import BulkContainerUpdate from './components/agent/BulkContainerUpdate';
// import { getStoredAgent } from './utils/helpers';
import './App.css';

function App() {
  // No longer track agent state for routing, only use token
  const handleLogin = () => {};

  const handleLogout = () => {
    sessionStorage.removeItem('agentToken');
  };

  function ProtectedRoute({ children }) {
    const agentToken = sessionStorage.getItem('agentToken');
    if (!agentToken) {
      return <Navigate to="/agent/login" replace />;
    }
    return children;
  }

  return (
    <Router>
      <div className="App">
  <Header onLogout={handleLogout} />
        
        <main className="main-content">
          <Routes>
            <Route 
              path="/" 
              element={<CustomerPortal />} 
            />
            {/* Public route for /track */}
            <Route 
              path="/track" 
              element={<CustomerPortal />}
            />
            
            {/* Agent routes */}
            <Route 
              path="/agent/login" 
              element={<AgentLogin onLogin={handleLogin} />} 
            />
            <Route 
              path="/agent/dashboard" 
              element={
                <ProtectedRoute>
                  <AgentDashboard />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/agent/bulk-container-update" 
              element={
                <ProtectedRoute>
                  <BulkContainerUpdate />
                </ProtectedRoute>
              }
            />
            
            <Route path="/detention-report" element={<DetentionReport />} />
            <Route path="/container-dwell-time-report" element={<ContainerDwellTimeReport />} />
            <Route path="/completed-voyage-report" element={<CompletedVoyageReport />} />
            
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;